"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertHex = exports.parseError = void 0;
const viem_1 = require("viem");
const Error_1 = require("../Error");
function parseError(error) {
    const parsedViemError = parseViemError(error);
    if (parsedViemError) {
        return parsedViemError;
    }
    if (error instanceof Error_1.KriptonioError) {
        return error;
    }
    return error;
}
exports.parseError = parseError;
function parseViemError(error) {
    // not using instanceof because if dependency library has different version of viem,
    // it will return false negative
    const viemError = error;
    if (viemError.details || viemError.shortMessage) {
        if (viemError.cause) {
            const causeViemError = viemError.cause;
            if (causeViemError.details || causeViemError.shortMessage) {
                return parseViemError(causeViemError);
            }
        }
        return new Error_1.KriptonioError({
            message: viemError.details ?? viemError.shortMessage,
            cause: viemError,
        });
    }
    return null;
}
function assertHex(value, propertyName) {
    if (!(0, viem_1.isHex)(value)) {
        throw new Error_1.KriptonioError({
            message: `Property ${propertyName} has invalid hex value: ${value}`,
        });
    }
    return value;
}
exports.assertHex = assertHex;
